const Utility = (objectToCopy,NewStates) =>(
    {
        ...objectToCopy,
        ...NewStates
    }
);

export default Utility;